export const GENDER_TYPE = {
  MALE: "male",
  FEMALE: "female",
};

export const genderArray = [GENDER_TYPE.MALE, GENDER_TYPE.FEMALE];
